import React from "react";
import { Box, Flex, Text, Button, Card } from "@radix-ui/themes";
import { LogOut } from "lucide-react";
import { config } from "@/config/env";

const LoggedOutPage = () => {
  return (
    <Flex
      align="center"
      justify="center"
      style={{
        minHeight: "100vh",
        background: "var(--gray-2)",
        padding: "20px",
      }}
    >
      <Card size="4" style={{ width: "100%", maxWidth: "450px" }}>
        <Flex direction="column" align="center" gap="4" py="4">
          <Box
            style={{
              padding: "16px",
              borderRadius: "50%",
              backgroundColor: "var(--orange-3)",
              color: "var(--orange-9)",
            }}
          >
            <LogOut size={32} />
          </Box>

          <Flex direction="column" align="center" gap="2">
            <Text size="6" weight="bold">
              Logged Out
            </Text>
            <Text size="2" color="gray" style={{ textAlign: "center" }}>
              You have been successfully logged out of this project instance.
            </Text>
          </Flex>

          <Flex direction="column" gap="2" width="100%" mt="2">
            <Button
              size="3"
              variant="solid"
              onClick={() => {
                if (window.parent !== window.self) {
                  window.parent.postMessage({ type: "exit-management" }, "*");
                } else {
                  window.location.href = config.centralAuthUrl;
                }
              }}
            >
              Return to MyAnythink
            </Button>
          </Flex>
        </Flex>
      </Card>
    </Flex>
  );
};

export default LoggedOutPage;
